import { render, staticRenderFns } from "./Waiting.vue?vue&type=template&id=37a6b28f"
import script from "./Waiting.vue?vue&type=script&lang=ts&setup=true"
export * from "./Waiting.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./Waiting.vue?vue&type=style&index=0&id=37a6b28f&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports